module.exports = __webpack_public_path__ + "static/media/web_logo.29ab1d79.png";